/**
 * PATH: apps/hr/src/components/settings/TagSettingsTab.tsx
 * PURPOSE: Tag management settings tab content for the Settings modal (real-data only)
 *
 * WHY:
 * - Previously this tab used mock tag data, which must not ship to production.
 * - Tag management is not yet backed by an HR API in this hub.
 */

import { Tag } from 'lucide-react'
import { EmptyState } from '../ui/EmptyState'

export function TagSettingsTab() {
  return (
    <EmptyState
      icon={Tag}
      title="Tags not connected"
      description="This settings tab has been cleaned up to remove dummy data. Once tags are backed by a real API, tag configuration will appear here."
    />
  )
}

export default TagSettingsTab
